/* eslint-disable @typescript-eslint/no-explicit-any */
import MarkDown from '~/components/Helpers/MarkDown'
import ContactLink, {
  ContactLinkProps
} from '~/components/UI/Buttons/ContactLink/ContactLink'
import Container from '~/layouts/Container'
import Full from '~/layouts/Full'
import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const backgroundColours = cva('before:lg:m-xs before:absolute before:inset-0', {
  variants: {
    colour: {
      'ink-blue': 'before:bg-blue-d',
      'mid-blue': 'before:bg-blue-m',
      'light-blue': 'before:bg-blue-l',
      'light-pink': 'before:bg-pink',
      'light-aqua': 'before:bg-green',
      'light-orange': 'before:bg-orange',
      'light-purple': 'before:bg-purple',
      white: 'before:bg-white'
    }
  },
  defaultVariants: {
    colour: 'ink-blue'
  }
})

type NextStepsProps = {
  content: {
    eyebrow?: string
    heading: string
    buttons?: Array<ContactLinkProps['data']>
    form?: any
    showForm?: boolean
    sys?: { id?: string }
  }
  className?: string
  backgroundColour?:
    | 'ink-blue'
    | 'mid-blue'
    | 'light-blue'
    | 'light-pink'
    | 'light-aqua'
    | 'light-orange'
    | 'light-purple'
    | 'white'
    | null
    | undefined
}

const NextSteps = ({
  content,
  backgroundColour = 'mid-blue',
  className
}: NextStepsProps) => {
  const data = content

  return (
    <Container
      columns='full'
      padding={'small'}
      config={{
        sectionID: 'next-steps',
        sectionName: data?.heading,
        backgroundColour: 'white',
        edgetoedgeBackground: true
      }}
      className={cn(
        'my-2xl !py-s md:!py-l mx-auto lg:!py-[clamp(48px,4vw+40px,80px)]',
        'max-w-[calc(100%-40px)] sm:max-w-[604px] lg:max-w-[1560px]',
        className
        // '!p-s md:!p-l mx-auto 2xl:!p-[clamp(48px,4vw+40px,80px)]'
        // 'max-xl:max-w-[906px] max-lg:mx-auto max-lg:max-w-[640px] max-md:max-w-[calc(100%-40px)] max-md:mx-xs-plus'
      )}
    >
      <Full className={cn(backgroundColours({ colour: backgroundColour }))}>
        <div
          className={cn(
            !data?.showForm ? 'md:grid-cols-3' : 'lg:grid-cols-3',
            ['ink-blue', 'mid-blue'].includes(backgroundColour ?? '')
              ? 'text-white'
              : 'text-blue-d',
            'gap-l grid grid-flow-row grid-cols-1 lg:grid-cols-3',
            'items-start justify-between md:items-center',
            'relative'
            // 'py-2xl'
          )}
        >
          <div
            className={cn(
              !data?.showForm ? 'col-span-2' : '',
              'space-y-xs',
              'max-w-[40ch] lg:max-w-[50ch]'
            )}
          >
            <p className='tag'>{data?.eyebrow}</p>
            <MarkDown
              content={'## ' + data?.heading}
              className='max-w-[50ch] text-2xl font-bold md:max-w-[80ch]'
            />
          </div>

          <div className=''>
            {Array.isArray(data?.buttons) && (
              <ul className='space-y-xs list-none pl-0'>
                {data?.buttons?.map((contact, index: Index) => (
                  <li key={index}>
                    <ContactLink
                      data={contact}
                      colour={
                        ['ink-blue', 'mid-blue'].includes(
                          backgroundColour ?? ''
                        )
                          ? 'white'
                          : 'ink-blue'
                      }
                      className=''
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>

          {data?.showForm && data?.form && (
            <div className=''>Insert form here</div>
          )}
        </div>
      </Full>
    </Container>
  )
}

export default NextSteps

// gap-l lg:gap-2xl min-h-2xl relative container grid w-full grid-flow-row grid-cols-1 items-center bg-blue-m text-white md:grid-cols-1 py-l sm:py-xl lg:py-2xl my-2xl

// gap-l lg:gap-2xl min-h-2xl relative container grid w-full grid-flow-row grid-cols-1 [&>div]:justify-self-center [&>div>div]:mx-auto items-center md:grid-cols-1 py-xl sm:py-2xl lg:py-3xl

// gap-l lg:gap-2xl min-h-2xl relative container grid w-full grid-flow-row grid-cols-1 items-center bg-blue-m text-white md:grid-cols-1 py-l sm:py-xl lg:py-2xl my-2xl
